import { BoxProps, HStack, Icon, IconButton } from "@chakra-ui/react";
import HoneySlider from "components/HoneySlider";
import { PayFormValues } from "components/PayForm";
import { BigNumber } from "ethers";
import { FaLock, FaLockOpen } from "react-icons/fa";

type PayFormSliderProps = Omit<BoxProps, "onChange"> & {
  valueKey: string;
  label: string;
  values: PayFormValues;
  max: BigNumber;
  onChange: (valueKey: string, amount: BigNumber) => void;
  onLockToggle: (valueKey: string, isLocked: boolean) => void;
};

const PayFormSlider = ({
  valueKey,
  values,
  max,
  label,
  onChange,
  onLockToggle,
  ...rest
}: PayFormSliderProps) => (
  <HStack
    w="full"
    spacing="4"
    px="8"
    py="2"
    bg="dark.600"
    align="center"
    justify="center"
    {...rest}
  >
    <HoneySlider
      label={label}
      max={max}
      value={values[valueKey]?.amount || BigNumber.from("0")}
      onChange={(value: BigNumber) => onChange(valueKey, value)}
    />

    <IconButton
      borderRadius="full"
      colorScheme="dark"
      size="sm"
      aria-label=""
      color={values[valueKey]?.isLocked ? "secondary.500" : "bright.500"}
      _hover={{
        bg: "dark.500",
      }}
      icon={
        values[valueKey]?.isLocked ? (
          <Icon as={FaLock} />
        ) : (
          <Icon as={FaLockOpen} />
        )
      }
      onClick={() => onLockToggle(valueKey, !values[valueKey]?.isLocked)}
    />
  </HStack>
);

export default PayFormSlider;
